/**
 *  supplier JS
 *  Get/add/delete/modify
 */
$(document).ready(function () {
    function trans(translation) {
        var language = document.documentElement.lang;

        return _.get(window.i18n, language + "." + translation);
    }
    if (document.getElementById('supplier_hidden')) {
        /* create supplier */
        var modal = document.getElementById("myModal");
        var btn = document.getElementById("popupCreatesupplier");
        var span = document.getElementsByClassName("close")[0];
        btn.onclick = function () {
            modal.style.display = "block";
        };
        span.onclick = function () {
            modal.style.display = "none";
        };
        window.onclick = function (event) {
            if (event.target == modal) {
                modal.style.display = "none";
            }
        };
        $('#supplier_create_btn').on('click', function () {
            if (confirm(trans('page.management.supplier.add_supplier_q'))) {
                $.ajax({
                    url: '/manage/supplier/create',
                    type: "post",
                    dataType: "json",
                    data: {
                        name: $('#supplier_name').val(),
                        customer_number: $('#supplier_customer_number').val(),
                        is_dropshipping: $('#supplier_is_dropshipping').val(),
                        first_name: $('#supplier_firstname').val(),
                        last_name: $('#supplier_lastname').val(),
                        company: $('#supplier_company').val(),
                        email: $('#supplier_email').val(),
                        phone: $('#supplier_phone').val(),
                        street: $('#supplier_street').val(),
                        street_nr: $('#supplier_strnr').val(),
                        country: $('#supplier_countrycode').val(),
                        plz: $('#supplier_plz').val(),
                        city: $('#supplier_city').val(),
                        state: $('#supplier_state').val(),
                    },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        alert(trans('page.management.supplier.supplier_was_created'));
                        location.reload();

                    },
                    error: function (data) {
                        var json = data.responseJSON;
                        var errorMsg = trans('page.management.avis.avis_error');
                        var errors = Object.values(json.errors);
                        errors.forEach(function (value) {
                            if (value.isArray === true) {
                                value.forEach(function (msg) {
                                    errorMsg = errorMsg + '\n' + msg;
                                });
                            } else {
                                errorMsg = errorMsg + '\n' + value;
                            }
                        });
                        alert(errorMsg);
                    }
                });
            } else {
            }
        });
        $('#supplier_btn_u').on('click', function () {
            $.ajax({
                url: '/manage/supplier/update/' + $('#hidden_update_field').val(),
                type: "post",
                dataType: "json",
                data: {
                    name: $('#supplier_name_u').val(),
                    is_dropshipping: $('#supplier_is_drop_shipping_u').val(),
                    first_name: $('#supplier_firstname_u').val(),
                    last_name: $('#supplier_lastname_u').val(),
                    company: $('#supplier_company_u').val(),
                    email: $('#supplier_email_u').val(),
                    phone: $('#supplier_phone_u').val(),
                    street: $('#supplier_street_u').val(),
                    street_nr: $('#supplier_strnr_u').val(),
                    country: $('#supplier_countrycode_u').val(),
                    plz: $('#supplier_plz_u').val(),
                    city: $('#supplier_city_u').val(),
                    state: $('#supplier_state_u').val(),
                },
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    location.reload();

                },
                error: function () {
                }
            });
        });
        $('.supplier_update_btn_modal_open').on('click', function () {
            if (confirm(trans('page.supplier.view.add_supplier_q'))) {
                let split = this.id.split("_", 2);
                let modal = document.getElementById("myModal2");
                modal.style.display = "block";
                window.onclick = function (event) {
                    if (event.target == modal) {
                        modal.style.display = "none";
                    }
                };
                $.ajax({
                    url: '/manage/supplier/get/' + split[1],
                    type: "get",
                    dataType: "json",
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        $('#supplier_name_u').val(data["name"]);
                        $('#customer_number_u').val(data["customer_number"]);
                        $('#supplier_is_drop_shipping_u').val(data["is_dropshipping"]);
                        $('#supplier_firstname_u').val(data["address"]["first_name"]);
                        $('#supplier_lastname_u').val(data["address"]["first_name"]);
                        $('#supplier_company_u').val(data["address"]["company"]);
                        $('#supplier_email_u').val(data["address"]["email"]);
                        $('#supplier_phone_u').val(data["address"]["phone"]);
                        $('#supplier_street_u').val(data["address"]["street"]);
                        $('#supplier_strnr_u').val(data["address"]["housenumber"]);
                        $('#supplier_countrycode_u').val(data["address"]["country_code"]);
                        $('#supplier_plz_u').val(data["address"]["plz"]);
                        $('#supplier_city_u').val(data["address"]["city"]);
                        $('#supplier_state_u').val(data["address"]["state"]);
                        $('#hidden_update_field').val(data["address"]["id"]);
                    },
                    error: function () {
                        modal.style.display = "none";
                    }
                });

            } else {
            }
        });
        $('.supplier_delete_btn').on('click', function () {
            if (confirm(trans('page.supplier.view.delete_supplier_q'))) {
                let split = this.id.split("_", 2);
                $.ajax({
                    url: '/manage/supplier/delete/' + split[1],
                    type: "post",
                    dataType: "json",
                    data: {},
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        alert(trans('page.supplier.view.supplier_was_deleted'));
                        location.reload();

                    },
                    error: function () {
                    }
                });
            } else {
            }
        });
    }

});